/**
 * Pitch section registry — kept separate from PitchPage.tsx so the page
 * module exports only components (fast-refresh requirement).
 */

export interface PitchSectionDef {
  id: string;
  label: string;
}

export const PITCH_SECTIONS: PitchSectionDef[] = [
  { id: 'signal', label: 'Market signal' },
  { id: 'problem', label: 'Problem' },
  { id: 'product', label: 'Product' },
  { id: 'roi', label: 'ROI' },
  { id: 'market', label: 'Market' },
  { id: 'roadmap', label: 'Roadmap' },
  { id: 'business', label: 'Business model' },
  { id: 'security', label: 'Security' },
  { id: 'gtm', label: 'Go to market' },
  { id: 'capital', label: 'Pre seed allocation' },
];
